import React, { Component } from 'react';
import { connect } from "react-redux";
import { Grid, Row, Col, Image, ProgressBar} from 'react-bootstrap';
import {
    setLoader
} from "../../redux/actionCreators";

import managerService from '../../service/ManagerService';
import './review.css';

class Review extends Component {
    constructor(props) {
        super(props);   
        this.code = this.props.match && this.props.match.params && this.props.match.params.code;
        
        this.FACE_PHOTO = 'FACE_PHOTO';
        this.FACE_PHOTO_CROPPED = 'FACE_PHOTO_CROPPED';
        this.IDENTITY_CARD_BACK_FINGERPRINT_CROPPED = 'IDENTITY_CARD_BACK_FINGERPRINT_CROPPED';
        this.IDENTITY_CARD_FACE_CROPPED = 'IDENTITY_CARD_FACE_CROPPED';
        
        this.TEXT_FACIAL_RECOGNITION = 'Similitud obtenida en reconocimiento facial';
        this.TEXT_FACE_PHOTO = 'Fotografía del rostro del firmante';
        this.DEFAULT_TEXT_IDENTITY_VERIFICATION = 'Verificación de identidad';

        this.state = {
            existsCardBackFingerprint: false,
            photoFacePerson: '',
            croppedImage: '',
            textFacialRecognition: this.TEXT_FACIAL_RECOGNITION,
            textFacePhoto: this.TEXT_FACE_PHOTO,
            data: {},
        }
    }

    updatePhotoFacePerson() {
        let photoFacePerson = '';
        const existsFacePhotoCropped = this.state.data.data && this.state.data.data[this.FACE_PHOTO_CROPPED];
        const existsFacePhoto = this.state.data.data && this.state.data.data[this.FACE_PHOTO];
        if(existsFacePhotoCropped) {
            photoFacePerson = <Image className="identity-face" src={this.state.data.data[this.FACE_PHOTO_CROPPED]} />;
        } else if (existsFacePhoto) {
            photoFacePerson = <Image className="identity-face" src={this.state.data.data[this.FACE_PHOTO]} />;
        }
        this.setState({
            photoFacePerson: photoFacePerson,
        });
    }

    updateCroppedImage() {
        let croppedImage = '';
        const existsCardFace = this.state.data.data && this.state.data.data[this.IDENTITY_CARD_FACE_CROPPED];
        const existsCardBackFingerprint = this.state.data.data && this.state.data.data[this.IDENTITY_CARD_BACK_FINGERPRINT_CROPPED];
        if (existsCardFace) {
            croppedImage = <Image className="identity-face" src={this.state.data.data[this.IDENTITY_CARD_FACE_CROPPED]} />;
        } else if (existsCardBackFingerprint) {
            croppedImage = <Image className="identity-face" src={this.state.data.data[this.IDENTITY_CARD_BACK_FINGERPRINT_CROPPED]} />;
        }
        this.setState({
            existsCardBackFingerprint: existsCardBackFingerprint,
            croppedImage: croppedImage,
        });
    }

    updateTexts() {
        if (this.state.existsCardBackFingerprint) {
            this.setState({
                textFacialRecognition: this.DEFAULT_TEXT_IDENTITY_VERIFICATION,
                textFacePhoto: this.DEFAULT_TEXT_IDENTITY_VERIFICATION,
            });
        }
    }

    async componentDidMount() {
        const response = await managerService.getProcessData(this.code);
        if (response) {
            this.setState({
                data: response
            });
            this.updatePhotoFacePerson();
            this.updateCroppedImage();
            this.updateTexts();
        }
    }

    render() {
        const {photoFacePerson, croppedImage, textFacePhoto, textFacialRecognition} = this.state;
        return (
            <Grid className='review' fluid={true}>
                <Row>
                    <Col xs={12}>
                        <p className={'title'}>REVISIÓN DEL PROCESO DE FIRMA</p>
                        <p className={'text'}>El cliente <b>{this.state.data && this.state.data.person && this.state.data.person.name}</b> de rut <b>{this.state.data && this.state.data.person && this.state.data.person.identityCode}</b> ya finalizó el proceso de firma.</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <p className={'text'}>Fotografías de cédula de identidad del firmante (parte delantera y trasera).</p>
                    </Col>
                    <Col sm={6} className='card right-text'>
                        {this.state.data.data && this.state.data.data['IDENTITY_CARD_FRONT'] &&
                            <Image className="identity-card" src={this.state.data.data['IDENTITY_CARD_FRONT']} />
                        }
                    </Col>
                    <Col sm={6} className='card left-text'>
                        {this.state.data.data && this.state.data.data['IDENTITY_CARD_BACK'] &&
                            <Image className="identity-card" src={this.state.data.data['IDENTITY_CARD_BACK']} />
                        }
                    </Col>
                    <Col xs={12}>
                        <p className={'text'}>Firma realizada por el firmante. Debe ser similar a la que se muestra en la cédula de identidad.</p>
                    </Col>
                    <Col sm={12} className='center-text'>
                        {this.state.data.data && this.state.data.data['HANDWRITTEN_SIGNATURE'] &&
                            <Image className="identity-handwritten-signature" src={this.state.data.data['HANDWRITTEN_SIGNATURE']} />
                        }
                    </Col>
                    <Col xs={12}>
                        <p className={'text'}>{textFacePhoto}</p>
                    </Col>
                    <Col xs={6} className='right-text'>
                        {croppedImage}
                    </Col>
                    <Col xs={6} className='left-text'>
                        {photoFacePerson}
                    </Col>
                    <Col xs={12}>
                        {this.state.data.data && this.state.data.data['FACIAL_PERCENT'] &&
                            <div>
                                <p className={'text'}>{textFacialRecognition} <b>{Math.trunc(parseFloat(this.state.data.data['FACIAL_PERCENT']))}%</b></p>
                                <ProgressBar bsStyle={Math.trunc(parseFloat(this.state.data.data['FACIAL_PERCENT'])) > 85 ? 'success': 'warning'} now={Math.trunc(parseFloat(this.state.data.data['FACIAL_PERCENT']))}/>
                            </div>
                        }
                    </Col>
                </Row>
            </Grid>
        );

    }
}


const mapStateToProps = state => {
    return {
        loader: state.loader,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setLoader(loader) {
            dispatch(setLoader(loader));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Review);
